import {Shop} from './Shop';
import {SignIn} from './SignIn';
import {SignUp} from './SignUp';
import {Home} from './tabs/Home';
import {Product} from './Product';
import {SignOut} from './SignOut';
import {Reviews} from './Reviews';
import {Blog} from './tabs/Blog';
import {Checkout} from './Checkout';
import {InfoSaved} from './InfoSaved';
import {Profile} from './tabs/Profile';
import {OrderFailed} from './OrderFailed';
import {NewPassword} from './NewPassword';
import {EditProfile} from './EditProfile';
import {Description} from './Description';

import {MyPromocodes} from './MyPromocodes';
import {OrderHistory} from './OrderHistory';
import {LeaveAReview} from './LeaveAReview';
import {Categories} from './tabs/Categories';
import {DeleteAccount} from './DeleteAccount';
import {ForgotPassword} from './ForgotPassword';
import {OrderSuccessful} from './OrderSuccessful';
import {WishlistEmpty} from './tabs/WishlistEmpty'
import {MyPromocodesEmpty} from './MyPromocodesEmpty';
import {OrderHistoryEmpty} from './OrderHistoryEmpty';
import {VerifyEmail} from './verification/VerifyEmail';
import {VerifyPhone} from './verification/VerifyPhone';
import {SendPhoneOtp} from './verification/SendPhoneOtp';
import {SendEmailOtp} from './verification/SendEmailOtp';
import {PhoneVerified} from './verification/PhoneVerified';
import {EmailVerified} from './verification/EmailVerified';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {ShippingAndPaymentInfo} from './ShippingAndPaymentInfo';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import BookViewer from './BookViewer';
import Article from './Article'
import {Library} from './tabs/Library';

export const screens = {
  Home,
  Shop  ,
  Blog,
  SignUp,
  SignIn,
  Profile,
  Product,
  Reviews,
  SignOut,
  Checkout,
  Library,

  InfoSaved,
  Categories,
  VerifyPhone,
  Description,
  EditProfile,
  OrderFailed,
  NewPassword,
  VerifyEmail,
  OrderHistory,
  SendEmailOtp,
  MyPromocodes,
  SendPhoneOtp,
  LeaveAReview,
  DeleteAccount,
  PhoneVerified,
  WishlistEmpty,
  EmailVerified,
  ForgotPassword,
  OrderSuccessful,
  OrderHistoryEmpty,
  MyPromocodesEmpty,
  SignUpAccountCreated,
  ShippingAndPaymentInfo,
  ForgotPasswordSentEmail,
  BookViewer,
  Article,
  
};
